<template>
  <div class="developer-initiators">
    <BaseCard
      :has-divider="true"
      :has-main-container="true"
      base-card-title-class="app-font-semibold title mb-1"
      data-v-step="0"
    >
      <template v-slot:header-title>
        Originadores
      </template>
      <template v-slot:header-actions>
        <v-dialog
          :value="isModalAddOrEditActive"
          persistent
          max-width="600"
          @input="changeModalContext('create')"
        >
          <template v-slot:activator="{ on }">
            <BaseButton
              type="text"
              color="blueff"
              class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
              v-on="on"
            >
              Adicionar
            </BaseButton>
          </template>
          <BaseModal
            :show-indeterminate-progress="modalAddOrEdit.showIndeterminateProgress"
            :top-slot-content-title="modalAddOrEdit.topSlotContentTitle"
            :remove-button-close="modalAddOrEdit.removeButtonClose"
            :middle-slot-content-text-highlight="modalAddOrEdit.middleSlotContentTextHighlight"
            :middle-slot-content-text="modalAddOrEdit.middleSlotContentText"
            :middle-check-agree="modalAddOrEdit.middleCheckAgree"
            :bottom-buttons-align="modalAddOrEdit.bottomButtonsAlign"
            :bottom-slot-content-button-cancel-label="modalAddOrEdit.bottomSlotContentButtonCancelLabel"
            :bottom-slot-content-button-confirm-label="modalAddOrEdit.bottomSlotContentButtonConfirmLabel"
            :remove-button-cancel="modalAddOrEdit.removeButtonCancel"
            :remove-button-confirm="modalAddOrEdit.removeButtonConfirm"
            :custom-enable-bottom-button-confirm-label="(valid && modalAddOrEdit.middleCheckAgree == null) || (modalAddOrEdit.middleCheckAgree !== null && modalAddOrEdit.middleCheckAgree.isChecked)"
            @on-cancel="modalAddOrEdit.onCancel"
            @on-confirm="modalAddOrEdit.onConfirm"
            @input="(value) => checkAgree(value)"
          >
            <template
              v-if="modalAddOrEdit.middleCheckAgree == null"
              v-slot:default
            >
              <div style="margin: 0 auto">
                <v-form
                  ref="formAddOrEdit"
                  v-model="valid"
                >
                  <v-container>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <BaseInput
                          v-model="initiator.name"
                          :rules="[isValid]"
                          qa-identification-name="qa-id-name-initiator-name"
                          label="Nome *"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <BaseInput
                          v-model="initiator.code"
                          :rules="[isValid, isNoSpaceValid]"
                          qa-identification-name="qa-id-name-initiator-code"
                          label="Código *"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        sm="2"
                        class="pb-0"
                      >
                        <v-checkbox
                          v-model="hasAlias"
                          primary
                          label="Alias"
                          hint="Basear-se em um originador já existente."
                          class="mt-6 mb-0"
                        />
                      </v-col>
                      <v-col
                        v-if="hasAlias"
                        class="pb-0"
                      >
                        <v-select
                          v-model="initiator.alias"
                          :items="getInitiators"
                          label="Originador *"
                          qa-identification-name="qa-id-name-initiator-initiator"
                          :rules="[isValid]"
                        />
                      </v-col>
                    </v-row>
                     <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="initiator.services"
                          :items="initiatorsServices"
                          :rules="[isValid]"
                          multiple
                          chips
                          item-text="name"
                          item-value="id"
                          label="Serviços contratados"
                        >
                          <template v-slot:append-outer>
                            <BaseButton
                              v-if="!showNewServiceFields"
                              :has-icon="true"
                              color="primary"
                              class="ma-0 pa-0"
                              @click="showNewServiceFields = true"
                              >
                              <v-icon small>
                                mdi-plus
                              </v-icon>
                            </BaseButton>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <template v-if="showNewServiceFields">
                      <p class="px-1">Cadastrar novo serviço</p>
                      <v-row dense>
                        <v-col
                          cols="auto"
                          sm="5"
                        >
                          <BaseInput
                            v-model="newService.id"
                            :rules="[isValid]"
                            label="Código serviço *"
                          />
                        </v-col>
                        <v-col
                          cols="auto"
                          sm="7"
                        >
                          <BaseInput
                            v-model="newService.name"
                            :rules="[isValid]"
                            label="Nome Serviço *"
                          >
                            <template v-slot:append-outer>
                              <BaseButton
                                :has-icon="true"
                                color="primary"
                                class="ma-0 pa-0"
                                :is-disabled="!newService.name || !newService.id"
                                @click="createInitiatorService()"
                                >
                                <v-icon small>
                                  mdi-plus
                                </v-icon>
                              </BaseButton>
                               <BaseButton
                                :has-icon="true"
                                color="primary"
                                class="ma-0 pa-0"
                                @click="hideInitiatorServeiceFields()"
                                >
                                <v-icon small>
                                  mdi-delete
                                </v-icon>
                              </BaseButton>
                            </template>
                          </BaseInput>
                        </v-col>
                      </v-row>
                    </template>
                  </v-container>
                </v-form>
              </div>
            </template>
          </BaseModal>
        </v-dialog>
      </template>
      <v-col sm="3">
        <BaseInput
          ref="filter"
          v-model="filterName"
          clearable
          label="Filtrar"
        />
      </v-col>
      <BaseDataTable
        :headers="headers"
        :items="filterInitiatorList"
        :hide-actions="false"
        background-color="transparent"
        :options="pagination"
      >
        <template v-slot:inject-items="scopedItems">
          <tr
            v-for="value in scopedItems"
            :key="value.index"
          >
            <td>
              {{ value.item.name }}
            </td>
            <td>
              {{ value.item.code }}
            </td>
            <td class="color--text-black-038">
              {{ value.item.alias }}
            </td>
            <td>
              <BaseTextTooltip
                :text-item="value.item.services ? parseServices(value.item.services) : '-'"
                width-item="195"
              />
            </td>
            <td class="text-right" width="150">
              <BaseButton
                type="text"
                color="blueff"
                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                @click="changeModalContext('edit', value.item)"
              >
                Editar
              </BaseButton>
              <BaseButton
                v-if="false"
                type="text"
                color="blueff"
                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                @click="changeModalContext('delete', value.item)"
              >
                Apagar
              </BaseButton>
            </td>
          </tr>
        </template>
        <template v-slot:custom-text-no-data>
          <div class="text-center">
            Nenhum arquivo para exibir
          </div>
        </template>
      </BaseDataTable>
    </BaseCard>
    <BaseSnackbar
      :active-snackbar="feedback"
      :type-snackbar="feedbackColor"
      :text-snackbar="feedbackMessage"
      @closeSnackbar="feedback = !feedback"
    />
  </div>
</template>

<script>
import BaseDataTable from '../../BaseDataTable'
import BaseModal from '../../BaseModal'
import { mapActions, mapGetters, mapState } from 'vuex'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../../BaseSnackbar'
import BaseTextTooltip from '../../BaseTextTooltip'

export default {
  name: 'DeveloperInitiators',
  components: { BaseDataTable, BaseModal, BaseSnackbar, BaseTextTooltip },
  mixins: [BaseSnackbarConfiguration],
  data() {
    return {
      filterName: '',
      valid: false,
      isModalAddOrEditActive: false,
      modalAddOrEdit: {},
      initiator: {},
      hasAlias: false,
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      headers: [
        {
          text: 'Nome',
          value: 'name',
          sortable: false
        },
        {
          text: 'Code',
          value: 'Code',
          sortable: false
        },
        {
          text: 'Alias',
          value: 'alias',
          sortable: false
        },
        {
          text: 'Serviços contratados',
          value: 'services',
          sortable: false
        },
        {
          text: '',
          value: 'uuid',
          sortable: false,
          align: 'end'
        }
      ],
      showNewServiceFields: false,
      newService: {}
    }
  },
  computed: {
    ...mapGetters(['getInitiators']),
    ...mapState({
      initiators: state => state.common.initiators.sort((a, b) => a.code.localeCompare(b.code)),
      initiatorsServices: state => state.common.initiatorsServices
    }),
    filterInitiatorList() {
      if (!this.filterName) {
        return this.initiators
      } else {
        return this.initiators.filter(initiator =>
          initiator.code.toLowerCase().includes(this.filterName.toLowerCase())
        )
      }
    }
  },
  async created(){
    this.setDefaultModal()
    await this.apiGetInitiators()
    await this.apiGetInitiatorsServices()
  },
  methods: {
    ...mapActions(['apiGetInitiators', 'apiUpdateInitiator', 'apiCreateInitiator', 'apiDeleteInitiator', 'apiGetInitiatorsServices', 'apiCreateInitiatorsServices']),
    closeModalAddOrEdit(){
      this.isModalAddOrEditActive = false
      if(this.$refs.formAddOrEdit){
        this.$refs.formAddOrEdit.reset()
      }
      this.initiator = {}
      this.hideInitiatorServeiceFields()
      this.checkAgree(false)
      this.setDefaultModal()
    },
    setDefaultModal(){
      Object.assign(this.modalAddOrEdit, {
        showIndeterminateProgress: false,
        topSlotContentTitle: "Adicionar Originador",
        removeButtonClose: true,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Salvar",
        middleCheckAgree: null,
        removeButtonCancel: false,
        removeButtonConfirm: false,
        onCancel: this.closeModalAddOrEdit,
        onConfirm: () => this.crudInitiator('create'),
      })
    },
    checkAgree(value) {
      if(this.modalAddOrEdit.middleCheckAgree){
        this.$set(this.modalAddOrEdit.middleCheckAgree, 'isChecked', value)
        this.$forceUpdate()
      }
    },
    changeModalContext(context, item = {}){
      Object.assign(this.initiator, item)
      this.hasAlias = item.alias ? true : false

      if(context == 'create'){
        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Adicionar Originador",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Adicionar",
            middleCheckAgree: null,
            onConfirm: () => this.crudInitiator('create')
          }
        )
      } else if(context == 'edit') {
        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Editar Originador",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Salvar",
            middleCheckAgree: null,
            onConfirm: () => this.crudInitiator('update')
          }
        )
      } else if(context == 'delete') {
        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Excluir Originador",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Excluir",
            middleCheckAgree: {
              "text": "Estou ciente de que após clicar no botão excluir, a ação não poderá ser desfeita.",
              "isChecked": false,
            },
            middleSlotContentText: `<p class='my-6'>Tem certeza que deseja <b>excluir o originador ${this.initiator.name}</b>?</p>`,
            onConfirm: () => this.crudInitiator('delete')
          }
        )
      }
      this.isModalAddOrEditActive = true
    },
    async crudInitiator(action){
      const responseMsg = {
        'create': ['criado', 'criar'],
        'delete': ['excluído', 'excluir'],
        'update': ['editado', 'editar']
      }
      const payload = {
        ...this.initiator
      }
      try {
        switch(action){
          case 'update':
            await this.apiUpdateInitiator(payload)
            break
          case 'create':
            await this.apiCreateInitiator(payload)
            break
          case 'delete':
            await this.apiDeleteInitiator(this.initiator.uuid)
            break
        }
        this.closeModalAddOrEdit()
        await this.apiGetInitiators()
        this.showFeedback({
          color: "success",
          message: `Originador ${responseMsg[action][0]} com sucesso!`,
        })
      } catch (error) {
        this.showFeedback({
          color: "error",
          message: `Erro ao ${responseMsg[action][1]} originador!`,
        })
      }
    },
    parseServices(services) {
      let serviceList = []

      if(services.length){
        services.forEach(service => {
          let item = this.initiatorsServices.find(iniServ => iniServ.id === service)
          let addItem = item ? item.name : service
          serviceList.push(addItem)
        });
      }
      return serviceList.join(', ')
    },
    hideInitiatorServeiceFields() {
      this.showNewServiceFields = false
      this.newService = {}
    },
    async createInitiatorService() {
      try {
        this.initiator.services.push(this.newService.id)
        await this.apiCreateInitiatorsServices(this.newService)
        await this.apiGetInitiatorsServices()
        this.hideInitiatorServeiceFields()
      } catch (error) {
        const msgError = {
          "400": "Erro ao cadastrar serviço. Verifique os dados enviados ou tente novamente.",
          "409": "O código desse serviço já existe. Use outro código ou selecione o serviço na lista de opções já existentes."
        }
        this.showFeedback({
          color: "error",
          message: msgError[error.response.status] || msgError[400],
        })
      }
    }
  }
}
</script>

